import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-home-apps',
    templateUrl: './home-apps.component.html',
    styleUrls: ['./home-apps.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeAppsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
